// Shared site constants and URL helpers for SEO.
// The real site origin comes from the VITE_SITE_URL environment variable.

export const SITE_URL: string = (
  (import.meta.env.VITE_SITE_URL as string | undefined) ?? ""
).replace(/\/+$/, "");

export const SITE_NAME = "AllChinaBuy Spreadsheet";

// Authoritative image provided via project embed data (favicon).
export const SITE_OG_IMAGE =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png";

export function absoluteUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return SITE_URL ? `${SITE_URL}${normalized}` : normalized;
}